const successSound = new Audio('successSound.wav');

const failureSound = new Audio('failureSound.wav');

const playSuccessSound = () => successSound.play();
const playFailureSound = () => failureSound.play();

export { playFailureSound, playSuccessSound };
